/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import isEmpty from 'lodash/isEmpty';

import ContentContainer from '../components/contentContainer';
import WidgetDialog from '../components/dialogs';
import TitleHeader from '../components/titleHeader';
import ErrorMsgBox from '../components/errorMsgBox';

import CommonImages from '../../commons/images';
import useTranslator from '../../commons/translations';

import useErrors from '../../store/models/errors/useErrors';

import { useStyles } from './styles';

function Errors (props) {

    const classes = useStyles();
 
    const defaultWidget = {
        logo: CommonImages.ECAL_LOGO_ROUND,
        logoShape: 'round',
    };

    const { error } = useErrors();
    const {
        translate,
    } = useTranslator();

    return (
        <React.Fragment>
            <ContentContainer
                id="content"
                className={classes.container}
            >
                 <WidgetDialog
                    isShowBackButton={false}
                >
                    <TitleHeader
                        widget={defaultWidget}
                    />

                    { 
                        !isEmpty(error) && 
                        <ErrorMsgBox 
                            title={translate(error.title)}
                            message={translate(error.message)}
                            refId={error.refId}
                        /> 
                    }

                </WidgetDialog>
            </ContentContainer>          
        </React.Fragment>
    );
}

export default Errors;